import React from "react";
import ProposalGenerationWizardForm from "./proposalGenerationWizardForm";
import NavHeightAdjust from "../../../../../components/navbar/NavHeightAdjust";

const ProposalWizard = () => {
  return (
    <NavHeightAdjust>
      <h1 className="text-2xl font-bold mb-4">Proposal Wizard</h1>
      <ProposalGenerationWizardForm />
    </NavHeightAdjust>
  );
};

export default ProposalWizard;
